// import { useState } from "react";
// import { useNavigate } from "react-router-dom";

// function ForgotPassword() {
//   const [phone, setPhone] = useState("");
//   const navigate = useNavigate();

//  const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await fetch(
//         "https://borrowhub-backend.onrender.com/api/auth/forgot-password",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ phone }),
//         }
//       );

//       const data = await res.json();

//       if (!res.ok) {
//         alert(data.message);
//         return;
//       }

//       // 🔥 FIXED LOGIC: Agar WhatsApp fail hua, toh alert mein OTP dikhega
//        // 🔥 FALLBACK CHECK
//       if (data.fallbackOtp) {
//            window.Swal.fire({
//             title: '<strong style="color: #d33">⚠️ OTP CODE</strong>', // Title badal diya
//             html: `
//                 <div style="font-size: 16px; margin-bottom: 5px;">Use this OTP to Verify:</div>
//                 <div style="font-size: 40px; font-weight: bold; color: #d33; border: 2px dashed red; padding: 10px; background: #fff0f0;">
//                     ${data.fallbackOtp}
//                 </div>
//                 <div style="margin-top: 10px; font-size: 12px; color: #555;">
//                     Closing in <b id="timer" style="color: red; font-size: 14px;">5</b> seconds...
//                 </div>
//             `,
//             icon: 'warning',
//             allowOutsideClick: false,
//             allowEscapeKey: false,
//             showConfirmButton: false, 
//             timer: 6000, 
//             didOpen: () => {
//                 const b = window.Swal.getHtmlContainer().querySelector('#timer');
//                 let timeLeft = 5;
//                 const timerInterval = setInterval(() => {
//                     timeLeft--;
//                     if(b) b.textContent = timeLeft;
//                     if(timeLeft <= 0) {
//                         clearInterval(timerInterval);
//                         window.Swal.update({ 
//                             showConfirmButton: true, 
//                             confirmButtonText: '✅ I COPIED IT',
//                             confirmButtonColor: '#d33'
//                         });
//                     }
//                 }, 1000);
//             }
//         });
//       } else {
//           alert("OTP sent to your WhatsApp number");
//       }

//       // OTP PAGE PE BHEJO
//       navigate("/verify-otp", {
//         state: { phone, type: "forgot" },
//       });

//     } catch (error) {
//       alert("Server error");
//     }
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center min-vh-100">
//       <form
//         onSubmit={handleSubmit}
//         className="card p-4 shadow"
//         style={{ width: "350px" }}
//       >
//         <h4 className="text-center mb-3">Forgot Password</h4>

//         <input
//           type="text"
//           className="form-control mb-3"
//           placeholder="Enter registered phone number"
//           value={phone}
//           onChange={(e) => setPhone(e.target.value)}
//           required
//         />

//         <button className="btn btn-success w-100">
//           Send OTP
//         </button>
//       </form>
//     </div>
//   );
// }

// export default ForgotPassword;


 import { useState } from "react";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });

      const data = await res.json();
      if (!res.ok) return alert(data.message);

      // 🔥 WhatsApp ka kissa khatam, seedha OTP pakdo
      const finalOtp = data.otp || data.fallbackOtp;

      if (finalOtp) {
        window.Swal.fire({
          title: '<strong style="color: #d33">⚠️ OTP CODE</strong>',
          html: `
                <div style="font-size: 16px; margin-bottom: 5px;">Use this OTP to Reset Password:</div>
                <div style="font-size: 40px; font-weight: bold; color: #d33; border: 2px dashed red; padding: 10px; background: #fff0f0;">
                    ${finalOtp}
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #555;">
                    Closing in <b id="timer" style="color: red; font-size: 14px;">5</b> seconds...
                </div>
            `,
          icon: 'warning',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false, 
          timer: 6000, 
          didOpen: () => {
            const b = window.Swal.getHtmlContainer().querySelector('#timer');
            let timeLeft = 5;
            const timerInterval = setInterval(() => {
                timeLeft--;
                if(b) b.textContent = timeLeft;
                if(timeLeft <= 0) {
                    clearInterval(timerInterval);
                    window.Swal.update({ 
                        showConfirmButton: true, 
                        confirmButtonText: '✅ I COPIED IT',
                        confirmButtonColor: '#d33'
                    });
                }
            }, 1000);
          },
          willClose: () => {
            navigate("/verify-otp", { state: { phone, type: "forgot" } });
          }
        });
      } else {
        // Agar OTP nahi mila toh bina alert ke navigate kar jao
        navigate("/verify-otp", { state: { phone, type: "forgot" } });
      }
    } catch (error) {
      alert("Server error");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <form onSubmit={handleSubmit} className="card p-4 shadow" style={{ width: "350px" }}>
        <h4 className="text-center mb-3">Forgot Password</h4>
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Enter registered phone number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
        <button className="btn btn-success w-100">Send OTP</button>
      </form>
    </div>
  );
}

export default ForgotPassword;